<div class="container petitioner-add-user">
  <form [formGroup]="userForm" (ngSubmit)="userDetailsFormSub()">
    <div class="form-row">
      <h6 class="pl-1"><b>Select the company you wish to add the user</b></h6>
    </div>
    <div class="form-row mb-2" *ngIf="showDdr">
      <div class="form-group col-md-4">
        <label>Select company <span class="required"></span></label>
        <p-dropdown placeholder="Select" class="p-form-control w-100" [options]="listCompany"
          formControlName="companyId" optionValue="id" optionLabel="companyName" (onChange)="companySelected($event)"
          name="companyName" [disabled]="isDisabled">
        </p-dropdown>
        <span class="mb-minus-2-5 error"
          *ngIf="userForm.get('companyId').touched && userForm.get('companyId').errors?.required">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </span>
      </div>
    </div>
    <div class="form-row" *ngIf="!showDdr">
      <div class="form-group col-md-4">
        <input class="form-control" type="text" [readonly]="true" value="{{ companyName }}" />
      </div>
    </div>
    <div class="row">
      <h6><b>Enter the user details for the selected company</b></h6>
    </div>
    <div class="form-row">
      <div class="form-group col-md-4">
        <label>First Name <span class="required"></span></label>
        <input class="im-input" name="firstName" formControlName="firstName" type="text" placeholder="Enter" />
      </div>
      <div class="form-group col-md-4">
        <label>Last Name <span class="required"></span></label>
        <input class="im-input" name="lastName" formControlName="lastName" type="text" placeholder="Enter" />
      </div>
      <div class="form-group col-md-4">
        <label>Middle Name</label>
        <input class="im-input" name="middleName" formControlName="middleName" type="text" placeholder="Enter" />
      </div>
    </div>

    <div class="row">
      <div class="form-group col-md-4 pl-0">
        <div class="mb-minus-2-5 error"
          *ngIf="userForm.get('firstName').touched && userForm.get('firstName').errors?.required">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </div>
      </div>
      <div class="form-group col-md-4 pl-1">
        <div class="mb-minus-2-5 error"
          *ngIf="userForm.get('lastName').touched && userForm.get('lastName').errors?.required">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </div>
      </div>
      <div class="form-group col-md-4"></div>
    </div>

    <div class="form-row">
      <div class="form-group col-md-4">
        <label>Designation <span class="required"></span></label>
        <input class="im-input" formControlName="designation" name="designation" type="text" placeholder="Enter" />
      </div>
      <div class="form-group col-md-4">
        <label>Email <span class="required"></span></label>
        <input class="im-input" name="email" type="text" placeholder="Enter" formControlName="email" />
      </div>
      <div class="form-group col-md-4">
        <label>Phone Number <span class="required"></span></label>
        <div class="d-flex phone-field">
          <p-dropdown [options]="listCountry" formControlName="phoneCode" optionValue="countryCode" optionLabel="labelWithCode" placeholder="Select Country" class="col-md-6 p-0 pr-1"></p-dropdown>
          <!-- <select class="form-control col-md-4 phoneCodeSelect" name="phoneCode" formControlName="phoneCode"
            placeholder="Select">
            <option *ngFor="let code of listCountry" [value]="code.countryCode">
              {{ code.countryName }} - {{ code.phoneCode }}</option>
          </select> -->
          <input class="im-input col-md-6 phoneInput" name="phone" formControlName="phone" type="text"
            placeholder="Phone Number" maxlength="10" />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-md-4 pl-0">
        <div class="mb-minus-2-5 error"
          *ngIf="userForm.get('designation').touched && userForm.get('designation').errors?.required">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </div>
      </div>
      <div class="form-group col-md-4 pl-1">
        <div class="mb-minus-2-5 error"
          *ngIf="userForm.get('email').touched && userForm.get('email').errors?.required">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </div>
        <div class="mb-minus-2-5 error"
          *ngIf="userForm.get('email').touched && userForm.get('email').errors?.pattern">
          {{ getGlobalErrorMessages("INVALID_EMAIL") }}
        </div>
      </div>
      <div class="form-group col-md-4 pl-0">
        <div class="mb-minus-2-5 error d-flex">
          <div class="col-md-6 pl-1 pr-0">
            <span class="pl-1" *ngIf="userForm.get('phoneCode').touched && userForm.get('phoneCode').errors?.required">
              {{ getGlobalErrorMessages("REQUIRED") }}
            </span>
          </div>
          <div class="col-md-6">
            <span class="pl-1" *ngIf="userForm.get('phone').touched && userForm.get('phone').errors?.required">
              {{ getGlobalErrorMessages("REQUIRED") }}
            </span>
            <span class="pl-1" *ngIf="userForm.get('phone').touched && userForm.get('phone').errors?.pattern">
              {{ getGlobalErrorMessages("INVALID_NUMBER") }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="row signatureUploadPortion" id="signatureUploadMain"> 
      <div class="col-12 p-2 mb-0 primaryContact pl-3"> 
        <section class=""> 
          <mat-checkbox class="mr-3 custom-checkbox" [checked]="userSignatory" [(ngModel)]="userSignatory" (change)="isUserSignatory($event)">This user is a signatory <img src="assets/Icon_signature.svg"></mat-checkbox>
          <mat-checkbox class="custom-checkbox" *ngIf="isPrimaryContact" [disabled]="isEnabledPrimary" [ngClass]="{'notAllowed': isEnabledPrimary}" [(ngModel)]="isIncludeAssociate" (change)="includeAssociate($event)">Make this user as primary contact <img src="assets/Icon_PrimaryContact.svg"></mat-checkbox>
        </section>  
      </div>

      <div class="col-8 pr-0 pb-3 signatureList" *ngIf="currentUserId && userSignatory">
        <div class="row mb-1 uploadHeading">Upload Signature</div>
        <table class="table">
          <thead>
            <tr>
              <th>Document Type</th>
              <!-- <th>Document Name</th> -->
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Signature Image</td>
              <!-- <td>
                  <span *ngIf="currentUserSignature && fileName">{{fileName}}</span>
                <span *ngIf="!currentUserSignature">No signature uploaded</span>              
              </td>   -->
              <td>
                <ng-template #fileUploadTemplate>
                  <div class="custom-file-upload">
                    <input type="file" id="fileUpload" name="files" (change)="uploadSignature($event, currentUserId)" hidden #fileInput>
                    <button type="button" *ngIf="!currentUserSignature" class="btn btn-outline-primary" matTooltip="Upload Signature" (click)="fileInput.click()">
                      <i class="fa fa-upload"></i>
                    </button>
                    <button type="button" *ngIf="currentUserSignature" class="btn btn-outline-primary replaceSignature" matTooltip="Replace Signature" (click)="fileInput.click()">
                      <img src="assets/Icon_replace.svg">
                    </button>
                  </div>
                </ng-template>
                
                <ng-container *ngIf="beforeDelete; else fileUploadTemplate">
                  <ng-container *ngTemplateOutlet="fileUploadTemplate"></ng-container>
                </ng-container>
                
                <i class="fa fa-trash-o mat-icon" *ngIf="currentUserSignature" aria-hidden="true" matTooltip="Delete Signature" (click)="confirmDeleteSignatory()"></i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row mt-3">
      <h6><b>Mailing Address</b></h6>
    </div>
    <div formGroupName="address">
      <div  class="form-row">
        <div class="form-group col-md-4">
          <label>Address 1</label><small class="text-secondary pl-1">Ex: Street Name & Number</small>
          <input pInputText class="im-input" formControlName="addressLine1" type="text" placeholder="Enter" maxLength="99"/>
        </div>
        <div class="form-group col-md-4">
          <label class="">Address 2</label> <i pTooltip='Enter Apartment, Suite, Floor number with the prefix Apt, Ste or Flr respectively. This will be automatically mapped to the Apartment, Suite and Floor fields in the forms' class="pl-1 pi pi-info-circle"></i>
          <input pInputText class="im-input" formControlName="addressLine2" type="text" placeholder="Enter" maxLength="99"/>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-4" formGroupName="countryCode">
          <label>Country</label>
          <p-dropdown class="w-100" [options]="listCountry" formControlName="countryCode" optionLabel="countryName" optionValue="countryCode" (onChange)="
            handleCountryChange($event.value)" placeholder="Select Country"></p-dropdown>
        </div>
        <div class="form-group col-md-4" *ngIf="listStates.length">
          <label>State</label>
          <p-dropdown class="w-100" [options]="listStates" formControlName="stateProvinceCode" optionLabel="stateProvinceName" optionValue="stateProvinceCode" placeholder="Select State"></p-dropdown>
        </div>
        <div class="form-group col-md-4" *ngIf="!listStates.length">
          <label>State</label>
          <input class="im-input" formControlName="stateProvinceName" type="text" placeholder="State" />
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-4">
          <label>City</label>
          <input class="im-input" formControlName="city" type="text" placeholder="City" />
        </div>
        <div class="form-group col-md-4">
          <label>Zip / Postal Code</label>
          <input class="im-input" formControlName="postCode" type="text" placeholder="Zip Code" maxLength="10" />
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-4 pl-0">
          <div class="mb-minus-2-5 error" *ngIf="
            (userForm.get('address')['controls']['postCode'].touched) &&
            userForm.get('address')['controls']['postCode'].errors?.pattern">
            {{ getGlobalErrorMessages("ZIPCODE_ONLY") }}
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex-start submitPortion">
      <button type="submit" class="im-btn btn-primary im-btn-md" mat-button>
        Save
      </button>
      <i class="pl-1 pi pi-info-circle" *ngIf="userSignatory && !currentUserId"></i><span *ngIf="userSignatory && !currentUserId"><i>After saving the individual details, go to the listing page to edit and upload the signature.</i></span>
    </div>
  </form>
</div>

<p-dialog [(visible)]="displayList" id="displayList" [style]="{ width: '40vw' }"> 
  <ng-template pTemplate="header">
   <h6><b>Delete Signatory</b></h6>
   <hr>
  </ng-template> 
    <div class="row contentMainPortion">
      <div class="col-1 pl-0 pr-0">
        <i class="pl-1 pi pi-info-circle customCircle"></i>
      </div>
      <div class="col-11 pl-0 pr-0 contentPortion">
        <p>You are about to Delete the signature</p>
        <p><b>You can re-upload the signature later if needed.</b></p>
        <p>Are you sure you want to proceed with <span class="warnPortion"> deletion?</span></p>
      </div>
    </div>
    <div class="row footerPortion">
      <button class="btn btn-defalt ml-0 cancelBtn" (click)="cancelAction()">Cancel</button>
      <button class="btn btn-danger ml-3" (click)="deleteSignatory(currentUserId)">Yes, Delete it</button>
    </div>
</p-dialog>